import React, { useState } from 'react';
import { X } from 'lucide-react';
import type { InnerCircleGroup } from '../../types/inner-circle';

interface CreateGroupModalProps {
  onSubmit: (data: {
    name: string;
    type: InnerCircleGroup['type'];
    description?: string;
  }) => void;
  onClose: () => void;
}

export function CreateGroupModal({ onSubmit, onClose }: CreateGroupModalProps) {
  const [name, setName] = useState('');
  const [type, setType] = useState<InnerCircleGroup['type']>('family');
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      name,
      type,
      description: description || undefined,
    });
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-[#2A2B2E] rounded-3xl p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold">Create New Group</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-black/20 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Group Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value as InnerCircleGroup['type'])}
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white [&>option]:bg-[#2A2B2E]"
            >
              <option value="family">Family</option>
              <option value="business">Business</option>
              <option value="friends">Friends</option>
            </select>
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">
              Description (Optional)
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white h-24 resize-none"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[var(--accent-color)] text-black rounded-xl py-3 font-medium hover:opacity-90 transition-opacity"
          >
            Create Group
          </button>
        </form>
      </div>
    </div>
  );
}